import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager } from "../../../../utils";

export const addState = createAsyncThunk('addState', async (data) => {

    try {
        const res = await axios({

            method: 'POST',
            url: process.env.REACT_APP_API_URL + 'state',
            data: {
                "country_id": data?.values?.country,
                "state": data?.values?.stateName,
                "status": data?.values?.status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})